export const ru = {
    no_hotels_found: 'Отелей не найдено, попробуйте изменить фильтры.',
};
